import {
    GET_ADVANCE_COMMENTS, INSERT_ADVANCE_COMMENT, GET_DOCUMNETS_COMMENTS_FOR_AP_TEAM,
} from '../type'

const initialState = {
    advanceComments: [],
    insertAdvanceComments: [],
    getCommentsForAll: [],
}

export default function advanceCommentsReducer(state = initialState, action) {
    switch (action.type) {

        case GET_ADVANCE_COMMENTS:
            return {
                ...state,
                advanceComments: action.payload,
                loading: false

            }
        case INSERT_ADVANCE_COMMENT:
            return {
                ...state,
                insertAdvanceComments: action.payload,
                loading: false

            }
        case GET_DOCUMNETS_COMMENTS_FOR_AP_TEAM:
            return {
                ...state,
                getCommentsForAll: action.payload,
                loading: false

            }

        default: return state
    }

}